import React from "react";

export default function PremiumHero({
  title,
  subtitle,
  accent = "#e11d7b",
  height = "h-[360px] md:h-[420px]"
}) {
  return (
    <section className="relative w-full overflow-hidden">
      <div
        className={`relative w-full ${height}`}
        style={{ backgroundColor: accent }}
      >
        <div
          className="absolute inset-0"
          style={{
            backgroundColor: accent,
            clipPath: "polygon(0 0, 100% 0, 85% 100%, 0 100%)"
          }}
        />

        <div className="relative z-10 h-full flex items-center text-white">
          <div className="max-w-xl pl-8 md:pl-16 pr-10">
            <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
              {title}
            </h1>

            {subtitle && (
              <p className="mt-4 text-base md:text-lg text-white/90">
                {subtitle}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
